exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".star-rating{width:100%}.star-rating i{max-width:16.67px;margin:0 3px!important}.star-rating i:focus{outline:none}", "", {"version":3,"sources":["/home/philipeatela/videopeel-plugin/src/components/StarRating/style.css"],"names":[],"mappings":"AAAA,aACE,UAAY,CACb,AAED,eACE,kBAAmB,AACnB,sBAAyB,CAC1B,AAED,qBACE,YAAc,CACf","file":"style.css","sourcesContent":[".star-rating {\n  width: 100%;\n}\n\n.star-rating i {\n  max-width: 16.67px;\n  margin: 0 3px !important;\n}\n\n.star-rating i:focus {\n  outline: none;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/StarRating/style.css
// module id = 845
// module chunks = 0 1